import React from "react";
import ReactDOM from "react-dom";

interface Props {
  toggler: JSX.Element;
}

const ChartsTogglerPortal = ({ toggler }: Props) => {
  const portal: HTMLElement | null = document.getElementById("MultipleTabs-chartToggler");

  if (portal) {
    return ReactDOM.createPortal(toggler, portal);
  } else {
    return <></>;
  }
};
export default ChartsTogglerPortal;
